module.exports = __webpack_public_path__ + "img/pro-head-photo2.5e57c011.png";